import { Component } from "@angular/core";
import { MatDialogRef } from "@angular/material/dialog";

@Component({
  selector: "app-inner-transfer",
  templateUrl: "./inner-transfer.component.html",
  styleUrls: ["./inner-transfer.component.scss"],
})
export class InnerTransferComponent {
  form = {
    search: "",
    customerInnerTransferTo: "",
    transferCost: 0,
    cashPaid: 0,
    visaPaid: 0,
    contactlessCashPaid: 0,
  };

  constructor(private dialogRef: MatDialogRef<InnerTransferComponent>) {}

  onSearch(): void {
    // handle customer search logic here
  }

  submit(): void {
    this.dialogRef.close(this.form);
  }

  close(): void {
    this.dialogRef.close();
  }
}
